import * as yup from 'yup';

export const schema = (messages: any) =>
  yup.object().shape({
    Name: yup
      .string()
      .required(messages['mailing.validate.create.name'].toString()),
    Subject: yup
      .string()
      .required(messages['mailing.validate.create.subject'].toString()),
    // Body: yup
    //   .string()
    //   .required(messages['mailing.validate.create.body'].toString()),
    EmailAccountId: yup
      .string()
      .required(messages['mailing.validate.create.EmailAccountId'].toString()),
    LanguageId: yup
      .string()
      .required(messages['mailing.validate.create.LanguageId'].toString()),
    CustomerCreatedDateFrom: yup
      .string()
      .required(
        messages[
          'mailing.validate.create.customerCreatedDateFrom.required'
        ].toString(),
      ),
    //   .nullable()
    //   .transform((curr, orig) => (orig === '' ? null : curr))
    //   .when('CustomerCreatedDateTo', {
    //     is: (val: any) => val && val !== '',
    //     then: yup.string().max(yup.ref('CustomerCreatedDateTo'), messages['mailing.validate.create.CustomerCreatedDateFrom.before'].toString()),
    //   }),
    CustomerCreatedDateTo: yup
      .string()
      .required(
        messages[
          'mailing.validate.create.customerCreatedDateTo.required'
        ].toString(),
      ),
    //   .nullable()
    //   .transform((curr, orig) => (orig === '' ? null : curr))
    //   .when('CustomerCreatedDateFrom', {
    //     is: (val: any) => val && val !== '',
    //     then: yup.string().min(yup.ref('CustomerCreatedDateFrom'), messages['mailing.validate.create.CustomerCreatedDateTo.after'].toString()),
    //   }),
    CustomerLastActivityDateFrom: yup
      .string()
      .required(
        messages[
          'mailing.validate.create.customerLastActivityDateFrom.required'
        ].toString(),
      ),
    //   .nullable()
    //   .transform((curr, orig) => (orig === '' ? null : curr))
    //   .when('CustomerLastActivityDateTo', {
    //     is: (val: any) => val && val !== '',
    //     then: yup.string().max(yup.ref('CustomerLastActivityDateTo'), messages['mailing.validate.create.CustomerLastActivityDateFrom.before'].toString()),
    //   }),
    CustomerLastActivityDateTo: yup
      .string()
      .required(
        messages[
          'mailing.validate.create.customerLastActivityDateTo.required'
        ].toString(),
      ),
    //   .nullable()
    //   .transform((curr, orig) => (orig === '' ? null : curr))
    //   .when('CustomerLastActivityDateFrom', {
    //     is: (val: any) => val && val !== '',
    //     then: yup.string().min(yup.ref('CustomerLastActivityDateFrom'), messages['mailing.validate.create.CustomerLastActivityDateTo.after'].toString()),
    //   }),
  });
